/**
 * The confetti burst when the cards are revealed. Kept in its own module so tests can mock it
 * (canvas-confetti draws on a <canvas>, which jsdom does not have).
 */
import confetti from "canvas-confetti";

export function celebrate(): void {
  void confetti({
    particleCount: 140,
    spread: 90,
    origin: { y: 0.6 },
    disableForReducedMotion: true,
  });
}
